import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from "../../../shared";
import { VoiceConversationContainer } from '../../../../../../../models/mongodbSchema/aggregates';


@Injectable({ providedIn: 'root' })
export class VoiceConversationService extends BaseApiTemplateService<VoiceConversationContainer> {

  constructor(private http: HttpClient) {
    super();

    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'voice';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'voice';
    this.httpClient = http;

    this.httpClient = http;
  }

}
